<main>
  <caixa-webcomponent-navigation-bar />

  <ng-template #magnifierTemplate>
    <i class="cds-icon-search"></i>
  </ng-template>
  <caixa-webcomponent-main-title [text]="'Relatório DFM | Demonstrativo Financeiro Mensal'"/>
  <bfm-monthly
    [headersFinancialRecords]="headersFinancialRecords"
    [bankDetailsFinancialRecords]="bankDetailsFinancialRecords"
    [prefixTitleFinancialRecords]="''"
  />
  <caixa-webcomponent-monthly-report-warning/>
</main>
